module.exports = __webpack_public_path__ + "fonts/MaterialIconsTwoTone-Regular.25c0aa42.otf";